import { EnvironmentConfigType } from '@smx-ui-relay/relay-types';

import { API } from '../common';

export const EnvironmentConfig: EnvironmentConfigType = {
    devToken: API.GRAPHQL_TOKEN,
    authUrl: '',
    envName: 'production',
    loadToken: () => Promise.resolve(null),
    saveToken: () => Promise.resolve(),
};
